export class CommentTypeReferenceModel {
    public commentTypeCode: string;
    public commentTypeName: string;
    public statusCode: string;
}